import React from 'react';

import usePreCompRegistrationOrganizationContacts from './UsePreCompRegistrationOrganizationContacts';

import PreCompOrganizationContactsGrid from '../../preComp/components/grids/PreCompOrganizationContactsGrid';

import PreCompRegistrationConstants from '../utils/PreCompRegistrationConstants';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PreCompRegistrationOrganizationContacts = () => {
  const {
    locationRegistrationNavState,
    gridState,
    pageErrorMessageState,
    onAddStaff,
    onDeleteStaff,
    onContinueClicked,
    onBackClicked
  } = usePreCompRegistrationOrganizationContacts();

  return (
    <LeftNav title={PreCompRegistrationConstants.LEFT_NAV_TITLE} state={locationRegistrationNavState} validateBeforeRedirect={false}>
      <Headings.H3>Organization Contacts</Headings.H3>
      <div className="row">
        <div className="col-xs-12">
          <p><b>*Both a Primary and Secondary Contact are required</b></p>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
        <ActionIntraPageButton onClick={onAddStaff}>Add Contact</ActionIntraPageButton>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <PreCompOrganizationContactsGrid
            data={gridState}
            isLoading={false}
            onDelete={onDeleteStaff} />
        </div>
      </div>
      {pageErrorMessageState &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{pageErrorMessageState}</p>
          </div>
        </div>}
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="button" onClick={onContinueClicked}>Continue</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
        </div>
      </div>
    </LeftNav>
  );
};

export default PreCompRegistrationOrganizationContacts;